import { getPblLawyerVettingStatus, hasPblRole, isPblCitizen, isPblOcAdminOrStaff } from '../../utils/pblRole';
import { FREE_LEGAL_LINK_APPLICATION } from '@/utils/applications';

export type PblHomeDashboard =
  | 'standard_home'
  | 'pbl_dashboard'
  | 'oc_authorization_form'
  | 'citizen_case_application'
  | 'lawyer_application_status'
  | 'lawyer_manage_cases';

export const resolvePblHomeDashboard = (
  userData?: any,
  activeApplication?: ApplicationKey | null
): PblHomeDashboard => {
  if (activeApplication && activeApplication !== FREE_LEGAL_LINK_APPLICATION) return 'standard_home';

  if (hasPblRole(userData, 'pbl_vetting_reviewer')) return 'pbl_dashboard';
  if (isPblOcAdminOrStaff(userData) || hasPblRole(userData, 'pbl_admin')) return 'pbl_dashboard';
  if (isPblCitizen(userData)) return 'pbl_dashboard';
  if (hasPblRole(userData, 'pbl_lawyer') && getPblLawyerVettingStatus(userData) !== 'approved') {
    return 'lawyer_application_status';
  }
  if (hasPblRole(userData, 'pbl_lawyer')) return 'pbl_dashboard';

  return 'standard_home';
};
